<template>
  <el-cascader
    size="small"
    v-model="value"
    :options="options"
    :props="props"
    filterable
    @change="change"
    clearable
  ></el-cascader>
</template>
<script>
import region from "@/api/region";
export default {
  props: ["qy"],
  data() {
    return {
      options: [],
      props: {
        emitPath: false,
        value: "regionKey",
        label: "regionName",
        children: "regions",
        checkStrictly: true,
      },
      value: this.qy,
    };
  },
  methods: {
    getRegion() {
      region().then((res) => {
        this.options = res.data.regions;
      });
    },
    change(val) {
      this.$emit("change", val);
    },
  },
  watch: {
    qy(now) {
      this.value = now;
    },
  },
  created() {
    this.getRegion();
  },
};
</script>
